module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("93l7U"))).then(() => parcelRequire('cvs7o'));